import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'stm',
    description:
      'STM App for managing mappings between targets and source systems.',
    icon: 'tie',
    name: 'STM',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
